/// <reference types="vite-plugin-svgr/client" />
import { forwardRef } from 'react'
import type { UnstyledButtonProps } from '@mantine/core'
import { UnstyledButton } from '@mantine/core'

import PencilIcon from '@/assets/icons/pencil.svg?react'

import classes from './ChangeAvatarButton.module.css'

export const ChangeAvatarButton = forwardRef<HTMLButtonElement>(
  ({ ...props }: UnstyledButtonProps, ref) => (
    <UnstyledButton ref={ref} {...props} className={classes.changeAvatarButton}>
      <PencilIcon />
    </UnstyledButton>
  ),
)
